import { render } from "./TemplatePreview.vue?vue&type=template&id=caec1bce&scoped=true"
import script from "./TemplatePreview.vue?vue&type=script&lang=ts"
export * from "./TemplatePreview.vue?vue&type=script&lang=ts"

import "./TemplatePreview.vue?vue&type=style&index=0&id=caec1bce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-caec1bce"

export default script